/* eslint-disable prettier/prettier */
export const LOG_DETAILS_FIELD_REGISTRY: Record<string, string> = {
  lastName: 'last name',
  firstName: 'first name',
  noOfChildren: 'number of children',
  birthdate: 'date of birth',
  'emergency contact nameP': "primary emergency contact's name",
  'emergency contact relationshipP': "primary emergency contact's relationship",
  'emergency contact phoneP': "primary emergency contact's primary phone number",
  'emergency contact phone2P': "primary emergency contact's secondary phone number",
  'emergency contact nameS': "secondary emergency contact's name",
  'emergency contact relationshipS': "secondary emergency contact's relationship",
  'emergency contact phoneS': "secondary emergency contact's primary phone number",
  'emergency contact phone2S': "secondary emergency contact's secondary phone number",
  'experience (isPresent)': 'experience (is present)',
  bank: 'bank name',
  branch: 'bank branch',
  accountNo: 'bank account number',
  mobile: 'mobile number',
  personalMobile: 'alternate mobile number',
  personalEmail: 'personal email address',
  passportExpiryDate: 'passport expiry date',
  'education detail (degree)': 'education detail (course)',
  aadharNo: 'aadhar number',
  zipCode: 'postal code',
  maritalStatus: 'marital status',
  isSpouseEmployed: 'spouse employment status',
  empId: 'employee ID',
  designationName: 'designation',
  referenceIdLinkedIn: 'linkedIn profile ID',
  referenceIdWhatsapp: 'whatsapp profile ID',
  referenceIdInstagram: 'instagram profile ID',
  referenceIdTwitter: 'twitter profile ID',
  referenceIdFacebook: 'facebook profile ID',
  joiningDate: 'joining date',
  disabled: 'user status (is disabled)',
  officeName: 'office name'
}
